export default __webpack_public_path__ + "static/media/plane-front.1c160d90.jpg";